import { memo, useCallback } from 'react'

import { setOpenModalWithParams } from 'state/app/reducer'
import { selectShowModal } from 'state/app/selectors'
import { ManageModalType } from 'state/futures/types'
import { useAppDispatch, useAppSelector } from 'state/hooks'

import { DelegationSubTab } from './DelegationTradingTab'
import RemoveDelegateModal from './RemoveDelegateModal'
import RenameAddressModal from './RenameAddressModal'

const DelegationManageModal = memo(() => {
	const dispatch = useAppDispatch()
	const openModal = useAppSelector(selectShowModal)

	const returnToDelegatesTab = useCallback(() => {
		dispatch(
			setOpenModalWithParams({
				type: 'futures_deposit_withdraw_smart_margin',
				params: { tab: ManageModalType.Delegation },
			})
		)
	}, [dispatch])

	const returnToSubAccoutnsTab = useCallback(() => {
		dispatch(
			setOpenModalWithParams({
				type: 'futures_deposit_withdraw_smart_margin',
				params: { tab: ManageModalType.Delegation, subTab: DelegationSubTab.SubAccounts },
			})
		)
	}, [dispatch])

	return (
		<>
			{openModal === 'remove_delegate' && <RemoveDelegateModal onDismiss={returnToDelegatesTab} />}
			{openModal === 'rename_delegate' && (
				<RenameAddressModal onDismiss={returnToDelegatesTab} type={'delegate'} />
			)}
			{openModal === 'rename_subaccount' && (
				<RenameAddressModal onDismiss={returnToSubAccoutnsTab} type={'subaccount'} />
			)}
		</>
	)
})

export default DelegationManageModal
